import { FC, useState } from "react";
import CallOutlineIcon from "@ht/shared/fonts/deos-pis/call-outline";
import ChatOutlineIcon from "@ht/shared/fonts/deos-pis/chat-outline";
import VideoOutlineIcon from "@ht/shared/fonts/deos-pis/video-outline";
import PlusIcon from "@ht/shared/fonts/deos-pis/plus";
import { Button } from "@ht/components";
import clsx from "clsx";
import ContactSearchSlideModal from "./ContactSearchSlideModal";

const Circle: FC = ({ children }) => {
    return <div className="rounded-full p-5 bg-primary-50">{children}</div>
}

const MessageBarIndex: FC = () => {
    const [showModal, setShowModal] = useState(false);
    const threeDot = (
        <div className="mx-4 flex justify-center items-center">
            <div className="min-w-[6px] min-h-[6px] rounded-full bg-primary" />
            <div className="min-w-[6px] min-h-[6px] rounded-full bg-primary mx-4" />
            <div className="min-w-[6px] min-h-[6px] rounded-full bg-primary" />
        </div>
    );
    const startNewHandler = () => {
        setShowModal(true);
    }
    return (
        <div className="flex flex-col items-center justify-center">
            <ContactSearchSlideModal visible={showModal} onClose={() => { setShowModal(false) }} />
            <div className="flex justify-center">
                <Circle><ChatOutlineIcon className="text-primary" /></Circle>
                {threeDot}
                <Circle><CallOutlineIcon className="text-primary" /></Circle>
                {threeDot}
                <Circle><VideoOutlineIcon className="text-primary" /></Circle>
            </div>
            <div className="text-gray-700 font-bold text-[20px] mt-8 ">
                Arsi Agent Web
            </div>
            <div className=" mt-3 text-gray-400 text-md font-normal text-center">
                Accept or start a chat, call & video call with users and help them <br />
                with their problems.
            </div>
            <div className="mt-8">
                <Button type="button" color="primary" onClick={startNewHandler}
                    className={clsx(
                        "!text-md !font-bold  rounded-md mt-[10px] !h-10 w-[220px] hover:bg-primary self-end"
                    )}>
                    <PlusIcon className="mr-3" /> Start New
                </Button>
            </div>
        </div>
    )
}

export default MessageBarIndex